import React from 'react';

const Checkout = () => {
    return (
        <div>
            <h2 className='text-center my-5'>This is checkout page</h2>
        </div>
    );
};

export default Checkout;